import { Signal } from '@angular/core';
import { IdBased } from '@app/shared/types/models/shared/id-based.model';
import { User } from '@app/shared/types/models/user/user.model';

export class CooperationUser implements IdBased {
  public id: string;
  public cooperationId: string;
  public user: Signal<User | undefined>;

  public constructor(data: Partial<CooperationUser>) {
    Object.assign(this, data);
  }
}
